module.exports = __webpack_public_path__ + "img/自主专区弹窗.png";